import React, { Component } from 'react'
import './Footer.css'

export default class Footer extends Component {
  render() {
    return (
    <>
      <footer role='contentinfo' className='footer bg-dark'>
        <p>Thoughtful Inc &copy; 2020</p>
      </footer>
    </>
    )
  }
}